import { __extends } from "tslib";
import { deserializeAws_json1_1ListIdentityPoolsCommand, serializeAws_json1_1ListIdentityPoolsCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { getAwsAuthPlugin } from "@aws-sdk/middleware-signing";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListIdentityPoolsCommand = /** @class */ (function (_super) {
    __extends(ListIdentityPoolsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListIdentityPoolsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListIdentityPoolsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getAwsAuthPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListIdentityPoolsCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1ListIdentityPoolsCommand(input, context);
    };
    ListIdentityPoolsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1ListIdentityPoolsCommand(output, context);
    };
    return ListIdentityPoolsCommand;
}($Command));
export { ListIdentityPoolsCommand };
//# sourceMappingURL=ListIdentityPoolsCommand.js.map